(function() {
	/**
	 * Renders Search page
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderSearchPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var parameters = props.context.querystring;
		if ((parameters.indexOf('q=') >= 0) && (parameters.indexOf('site=') === -1)) {
			var serializedterm = $('.js-search-form').serialize();
			parameters = parameters + '&' + serializedterm;
		}
		if (parameters === '') {
			var serializedterm = $('.js-search-form').serialize();
			parameters = serializedterm;
			//parameters = parameters + '&sort=date:D:R:d1&getfields=*&filter=0&requiredfields=URI';
		}
		var model = {
			element: null,
			template: 'templates/search.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				pageContent: null,
				searchResults: null,
				searchParams: null
			}
		};
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			WebBaseAprovLV.Utils.getSearchData(parameters),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr, searchXhr, tmplPage, tmplBreadcrumb, tmplSidebar) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			var searchRaw = Array.isArray(searchXhr) ? searchXhr[0] : (searchXhr || {});
			model.data.pageRaw = pageRaw;
			if (model.data.pageRaw) {
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					searchResults: searchRaw,
					searchParams: parameters
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();
